export const getDiffDaysToTimestamp = (timestamp: number): number => {
  return Math.ceil((timestamp - Math.floor(Date.now() / 1000)) / 86400);
}
